import { findArticleById } from '../../utils/findArticleById';
import { useEffect, useState } from 'react';
import { type OpenAPIV3_1 } from 'openapi-types';
import { type Article } from '../../models/articles';
import {
  findEndpointDefinitionByArticleId,
  findSwaggerRecord
} from '../../utils/findEndpointDefinitionByArticle';

export const useEndpointData = (
  articleId: string,
  swaggerDoc: OpenAPIV3_1.Document | null
) => {
  const [endpointDefinitionData, setEndpointDefinitionData] =
    useState<OpenAPIV3_1.OperationObject | null>(null);
  const [article, setArticle] = useState<Article | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const article = findArticleById(articleId);
        if (!article) {
          setLoading(false);
          setError('Article not found');
          return;
        }

        setArticle(article);
        if (swaggerDoc) {
          const matchingPath = findSwaggerRecord(article, swaggerDoc);

          setEndpointDefinitionData(
            matchingPath as OpenAPIV3_1.OperationObject
          );
        } else {
          const result = await findEndpointDefinitionByArticleId(article);
          setEndpointDefinitionData(result);
        }
      } catch (err) {
        console.error(err);
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [articleId]);

  return { endpointDefinitionData, article, loading, error };
};
